import { useEffect, useState } from "react";

// Default switch point (Tailwind `md`). Pass a custom min-width for layouts
// that switch at a different breakpoint (e.g. the basket scroll-container
// switch at 800px).
const DEFAULT_MIN_WIDTH = 768;

const getMatches = (query) =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(query).matches;

const useIsDesktop = (minWidth = DEFAULT_MIN_WIDTH) => {
  const query = `(min-width: ${minWidth}px)`;
  const [isDesktop, setIsDesktop] = useState(() => getMatches(query));

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }

    const mediaQueryList = window.matchMedia(query);
    const handleChange = (event) => setIsDesktop(event.matches);

    // Sync in case the viewport changed between render and effect.
    setIsDesktop(mediaQueryList.matches);

    mediaQueryList.addEventListener("change", handleChange);
    return () => mediaQueryList.removeEventListener("change", handleChange);
  }, [query]);

  return isDesktop;
};

export default useIsDesktop;
